import type { State } from 'redux-store/Store';

export const selectPartner = (state: State) => state.user.partner;
export const selectPassword = (state: State) => state.user.plainPassword;
export const selectUserId = (state: State) => state.user.id;
export const selectUser = (state: State) => state.user;
